/**
 * email 正規化 (§7 規約2)。Firestore のパス解決とルール照合はバイト単位の完全一致
 * のため、workspaces/migrations の doc ID・createdBy/updatedBy・editingBy・
 * 再送キューのキーは必ずこの1関数を通す。直接 auth.currentUser.email を使う実装は禁止。
 */
export function normalizedEmail(raw: string): string {
  return raw.trim().toLowerCase();
}

/**
 * 社内ドメイン。allowlist 登録なしで自動許可されるドメイン (§7)。
 * firestore.rules の isCompanyDomain() と同じ判定 — 変更する場合は両方直すこと。
 */
export const COMPANY_EMAIL_DOMAIN = 'grd.inc';

/**
 * 正規化済み (trim + 小文字化済み) email が社内ドメインかどうかを判定する。
 * firestore.rules の isCompanyDomain() ( `^[^@]+@grd[.]inc$` ) と同じ判定 —
 * 変更する場合は両方直すこと。
 *
 * endsWith('@grd.inc') で十分: 引数は既に正規化済みが前提のため、
 * 'a@grd.inc.evil.com' (末尾が evil.com) や 'a@sub.grd.inc' (末尾が sub.grd.inc)
 * のような紛らわしいドメインは末尾一致しないため false になる。
 */
export function isCompanyDomain(normalizedEmail: string): boolean {
  return normalizedEmail.endsWith(`@${COMPANY_EMAIL_DOMAIN}`);
}
